import { rgba } from "polished";
import styled from "styled-components";

const style = (Component) => styled(Component)`
  display: block;
  padding-bottom: clamp(6rem, 20vh, 10rem);

  .footer {
    margin-top: 3rem;
    text-align: center;
    font-family: ${(props) => props.theme.font.family["--font-family-mono"]};
    font-size: 0.6875rem;
    letter-spacing: 0.04em;
    color: ${(props) =>
      rgba(
        props.theme.colors[props.theme.currentVariant]["--color-text"],
        0.4,
      )};
  }

  .kofi-card {
    display: flex;
    align-items: center;
    gap: 0.875rem;
    margin-bottom: 1.5rem;
    text-decoration: none;
    border: 1px solid
      ${(props) =>
        rgba(
          props.theme.colors[props.theme.currentVariant]["--color-primary"],
          0.4,
        )};
    border-radius: ${(props) =>
      props.theme.borderRadius["--border-radius-base"]};
    background: ${(props) =>
      rgba(
        props.theme.colors[props.theme.currentVariant]["--color-primary"],
        0.1,
      )};
    padding: 1rem 1.25rem;
    color: ${(props) =>
      props.theme.colors[props.theme.currentVariant]["--color-primary"]};
    cursor: pointer;
    transition: all ${(props) => props.theme.transitions["--transition-base"]};

    &:hover {
      border-color: ${(props) =>
        rgba(
          props.theme.colors[props.theme.currentVariant]["--color-primary"],
          0.7,
        )};
      background: ${(props) =>
        rgba(
          props.theme.colors[props.theme.currentVariant]["--color-primary"],
          0.16,
        )};
    }

    strong {
      display: block;
      font-family: ${(props) => props.theme.font.family["--font-family-mono"]};
      font-size: ${(props) => props.theme.font.sizes["--font-size-small"]};
      font-weight: ${(props) => props.theme.font.weights["--font-weight-bold"]};
    }

    span span {
      display: block;
      font-family: ${(props) => props.theme.font.family["--font-family-mono"]};
      font-size: 0.75rem;
      opacity: 0.8;
    }
  }

  .actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .action-btn {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.625rem;
    white-space: nowrap;
    text-decoration: none;
    background: none;
    border: 1px solid
      ${(props) =>
        rgba(
          props.theme.colors[props.theme.currentVariant]["--color-text"],
          0.15,
        )};
    border-radius: ${(props) =>
      props.theme.borderRadius["--border-radius-base"]};
    padding: 0.75rem 1.25rem;
    font-family: ${(props) => props.theme.font.family["--font-family-mono"]};
    font-size: ${(props) => props.theme.font.sizes["--font-size-small"]};
    font-weight: ${(props) => props.theme.font.weights["--font-weight-bold"]};
    color: ${(props) =>
      props.theme.colors[props.theme.currentVariant]["--color-text"]};
    cursor: pointer;
    transition: all ${(props) => props.theme.transitions["--transition-base"]};

    &:hover:not(:disabled) {
      border-color: ${(props) =>
        rgba(
          props.theme.colors[props.theme.currentVariant]["--color-primary"],
          0.4,
        )};
      color: ${(props) =>
        props.theme.colors[props.theme.currentVariant]["--color-primary"]};
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }

    &.danger:hover:not(:disabled) {
      border-color: ${(props) =>
        rgba(
          props.theme.colors[props.theme.currentVariant]["--color-accent"],
          0.5,
        )};
      color: ${(props) =>
        props.theme.colors[props.theme.currentVariant]["--color-accent-text"]};
    }

    &.active {
      border-color: ${(props) =>
        rgba(
          props.theme.colors[props.theme.currentVariant]["--color-primary"],
          0.6,
        )};
      color: ${(props) =>
        props.theme.colors[props.theme.currentVariant]["--color-primary"]};
      background: ${(props) =>
        rgba(
          props.theme.colors[props.theme.currentVariant]["--color-primary"],
          0.12,
        )};
    }
  }

  .contact-form {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    border: 1px solid
      ${(props) =>
        rgba(
          props.theme.colors[props.theme.currentVariant]["--color-text"],
          0.15,
        )};
    border-radius: ${(props) =>
      props.theme.borderRadius["--border-radius-base"]};
    padding: 1rem 1.25rem;

    label {
      display: flex;
      flex-direction: column;
      gap: 0.375rem;
      font-family: ${(props) => props.theme.font.family["--font-family-mono"]};
      font-size: 0.75rem;
      color: ${(props) =>
        rgba(
          props.theme.colors[props.theme.currentVariant]["--color-text"],
          0.7,
        )};
    }

    input,
    textarea {
      border: 1px solid
        ${(props) =>
          rgba(
            props.theme.colors[props.theme.currentVariant]["--color-text"],
            0.2,
          )};
      border-radius: ${(props) =>
        props.theme.borderRadius["--border-radius-sm"]};
      padding: 0.5rem 0.625rem;
      background: ${(props) =>
        props.theme.colors[props.theme.currentVariant]["--color-background"]};
      font-family: ${(props) => props.theme.font.family["--font-family-mono"]};
      font-size: ${(props) => props.theme.font.sizes["--font-size-small"]};
      color: ${(props) =>
        props.theme.colors[props.theme.currentVariant]["--color-text"]};
      resize: vertical;

      &:focus {
        outline: 2px solid
          ${(props) =>
            props.theme.colors[props.theme.currentVariant]["--color-primary"]};
        outline-offset: 1px;
      }

      &:disabled {
        opacity: 0.5;
      }
    }

    .contact-status {
      font-family: ${(props) => props.theme.font.family["--font-family-mono"]};
      font-size: ${(props) => props.theme.font.sizes["--font-size-small"]};

      &.success {
        color: ${(props) =>
          props.theme.colors[props.theme.currentVariant]["--color-primary"]};
      }

      &.error {
        color: ${(props) =>
          props.theme.colors[props.theme.currentVariant][
            "--color-accent-text"
          ]};
      }
    }
  }

  .confirm-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-family: ${(props) => props.theme.font.family["--font-family-mono"]};
    font-size: ${(props) => props.theme.font.sizes["--font-size-small"]};
  }

  .confirm-btn {
    display: inline-flex;
    align-items: center;
    min-height: 44px;
    background: none;
    border: 1px solid
      ${(props) =>
        rgba(
          props.theme.colors[props.theme.currentVariant]["--color-text"],
          0.2,
        )};
    border-radius: ${(props) =>
      props.theme.borderRadius["--border-radius-base"]};
    padding: 0.5rem 0.875rem;
    cursor: pointer;
    color: ${(props) =>
      props.theme.colors[props.theme.currentVariant]["--color-text"]};

    &.danger {
      border-color: ${(props) =>
        rgba(
          props.theme.colors[props.theme.currentVariant]["--color-accent"],
          0.5,
        )};
      color: ${(props) =>
        props.theme.colors[props.theme.currentVariant]["--color-accent-text"]};
    }
  }
`;

export default style;
